export enum MergeSteps {
    FIRST = 1,
    SECOND,
    THIRD,
    FOURTH
}
